// Gudang Rido (desktop): menu tindakan lainnya (•••) pada kartu Shopee.
import { MoreHorizontal, Menu, Package, Boxes, Camera, Activity } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./components/ui/dropdown-menu";

export function RidoMoreMenu({ items, testId }) {
  return <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <button type="button" className="soft-btn shopee-wh-btn rido-more" aria-label="Tindakan lainnya" data-testid={testId}
        onClick={e => e.stopPropagation()}><MoreHorizontal size={18}/></button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" onClick={e => e.stopPropagation()}>
      {items.map(it => <DropdownMenuItem key={it.key} disabled={it.disabled} onSelect={it.onSelect} data-testid={`${testId}-${it.key}`}>
        {it.label}</DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>;
}

// Header Gudang Rido: tombol netral "Menu" → Pesanan Gudang / Stok Barang / Scan Pindah Tahap (fitur & hak akses tetap, hanya pindah tempat).
export function RidoHeaderMenu({ page, setPage, onScan, onPantau }) {
  return <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <button type="button" className="op-lock-link rido-menu-btn" aria-label="Menu: Pesanan Gudang / Stok Barang" data-testid="op-gudang-menu-btn">
        <Menu size={14} aria-hidden="true"/><span className="rido-menu-text">Menu</span></button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem onSelect={() => setPage("pesanan")} data-testid="op-gudang-nav-pesanan">
        <Package size={14}/> Pesanan Gudang{page === "pesanan" ? " ✓" : ""}</DropdownMenuItem>
      <DropdownMenuItem onSelect={() => setPage("stok")} data-testid="op-gudang-nav-stok">
        <Boxes size={14}/> Stok Barang{page === "stok" ? " ✓" : ""}</DropdownMenuItem>
      <DropdownMenuItem onSelect={onPantau} data-testid="op-gudang-nav-pantau">
        <Activity size={14}/> Pantau Produksi</DropdownMenuItem>
      <DropdownMenuItem onSelect={onScan} data-testid="operator-scan-barcode-btn">
        <Camera size={14}/> Scan Pindah Tahap</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>;
}
